/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

// NOTE: This should only be added as a child of <ProgressBar>
// There is a separate file mainly for organization purposes -
// separating files helps keep the logic in each more focused.

const styles = {
  progressBarTimeBadge: (leftAsPercent: string) => css`
    color: #dedede;
    position: absolute;
    top: -10px;
    transform: translate(-50%, -100%);
    border-radius: 10%;
    font-size: 14px;
    opacity: 0.75;
    background-color: #000;
    left: ${leftAsPercent};
  `,
  modernProgressBarTimeBadge: css`
    background-color: black;
    opacity: 0.8;
    border-radius: var(--cds-border-radius-100);
    padding: 8px 12px;
  `,
};

// TODO: potentially move these functions into a util file
const getFormattedTime = (time: number): string => {
  const padToTwoDigits = (num: $TSFixMe) => num.toString().padStart(2, '0');
  const timeInHours = Math.floor(time / 3600);
  const timeInMinutes = Math.floor((time % 3600) / 60);
  const timeInSeconds = Math.floor(time % 60);

  if (time < 0) {
    return '0:00';
  }

  if (timeInHours > 0) {
    return `${timeInHours}:${padToTwoDigits(timeInMinutes)}:${padToTwoDigits(timeInSeconds)}`;
  }

  return `${timeInMinutes}:${padToTwoDigits(timeInSeconds)}`;
};

type Props = {
  time: number;
  videoDuration: number;
};

const ProgressBarTimeBadge = ({ time, videoDuration }: Props) => {
  const fractionOffsetFromProgressBarStart = time / videoDuration;
  const percentOffsetFromProgressBarStart = `${(100 * fractionOffsetFromProgressBarStart).toFixed(2)}%`;

  return (
    <div
      className="rc-ProgressBarTimeBadge"
      css={[styles.progressBarTimeBadge(percentOffsetFromProgressBarStart), styles.modernProgressBarTimeBadge]}
    >
      <Typography2
        component="span"
        variant="bodySecondary"
        color="invertBody"
        data-testid="modern-progress-bar-time-badge"
      >
        {getFormattedTime(time)}
      </Typography2>
    </div>
  );
};

export default ProgressBarTimeBadge;
